module.exports = __webpack_public_path__ + "img/symbol_13_x50.f69f4c8d.png";